import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {Observable} from "rxjs";
import {
    AuthInterceptorSkipHeader,
    BaseUrlSkipHeader
} from "@webmate-web-core/shared/constants/interceptor-custom-headers.constants";

export interface IncidentsJSON {
    page: {
        updated_at: string
    },
    incidents: {
        name: string,
        updated_at: string,
        incident_updates: IncidentUpdate[]
    }[]
}

export interface IncidentUpdate {
    body: string,
    status: string,
    updated_at: string
}

export interface ScheduledMaintenanceJSON {
    page: {
        updated_at: string
    },
    scheduled_maintenances: {
        id: string,
        incident_updates: IncidentUpdate[],
        name: string,
        scheduled_for: string,
        scheduled_until: string,
        updated_at: string
    }[]
}

export enum ScheduledMaintenanceFilter {
    UPCOMING = 1,
    ACTIVE = 2,
    ALL = 3
}

@Injectable({
    providedIn: 'root'
})
export class IncidentsService {

    private readonly allIncidentsUrl = 'https://status.webmate.io/api/v2/incidents.json';
    private readonly unresolvedIncidentsUrl = 'https://status.webmate.io/api/v2/incidents/unresolved.json';

    private readonly upcomingScheduledMaintenancesUrl = 'https://status.webmate.io/api/v2/scheduled-maintenances/upcoming.json';
    private readonly activeScheduledMaintenancesUrl = 'https://status.webmate.io/api/v2/scheduled-maintenances/active.json';
    private readonly allScheduledMaintenancesUrl = 'https://status.webmate.io/api/v2/scheduled-maintenances.json';

    constructor(private http: HttpClient) {}

    fetchIncidents(onlyUnresolved: boolean): Observable<IncidentsJSON> {
        const url = onlyUnresolved ? this.unresolvedIncidentsUrl : this.allIncidentsUrl;
        const headers = new HttpHeaders().set(AuthInterceptorSkipHeader, '').set(BaseUrlSkipHeader, '');
        return this.http.get<IncidentsJSON>(url, {headers: headers});
    }

    fetchScheduledMaintenances(filter: ScheduledMaintenanceFilter): Observable<ScheduledMaintenanceJSON> {
        let url: string;
        switch (filter) {
            case ScheduledMaintenanceFilter.UPCOMING:
                url = this.upcomingScheduledMaintenancesUrl;
                break;
            case ScheduledMaintenanceFilter.ACTIVE:
                url = this.activeScheduledMaintenancesUrl;
                break;
            case ScheduledMaintenanceFilter.ALL:
                url = this.allScheduledMaintenancesUrl;
                break;
            default:
                console.error(`Unknown ScheduledMaintenanceFilter: ${filter}`);
        }
        const headers = new HttpHeaders().set(AuthInterceptorSkipHeader, '').set(BaseUrlSkipHeader, '');
        return this.http.get<ScheduledMaintenanceJSON>(url, {headers: headers});
    }

}
